import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { Component } from '@angular/core';
import * as saveAs from 'file-saver';
import { NgxSpinnerService } from 'ngx-spinner';
import { AutoUnsubscribe } from 'projects/cupcake/src/app/core/auto-unsubscribe';
import { SubSink } from 'subsink';
import { FormlyDocumentAttachmentsService } from '../formly-document-attachments.service';
import { switchMap, tap } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { of } from 'rxjs';
import { DeleteDocumentConfirmDialogComponent } from '../delete-document-confirm-dialog/delete-document-confirm-dialog.component';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@AutoUnsubscribe()
@Component({
  selector: 'app-ag-grid-document-attachment-action-renderer',
  templateUrl: './ag-grid-document-attachment-action-renderer.component.html',
  styleUrls: ['./ag-grid-document-attachment-action-renderer.component.scss'],
  imports: [MatIconButton, MatTooltip, MatIcon, TranslateModule],
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class AgGridDocumentAttachmentActionRenderer
  implements ICellRendererAngularComp
{
  subs = new SubSink();

  constructor(
    private documentAttachmentsService: FormlyDocumentAttachmentsService,
    private spinnerService: NgxSpinnerService,
    private dialog: MatDialog
  ) {}

  private id?: number;
  private data: any;

  isReadOnly = false;

  onDeleteClicked() {
    if (this.id) {
      this.subs.sink = this.dialog
        .open(DeleteDocumentConfirmDialogComponent, {
          maxWidth: '33%',
          minWidth: '25vw',
          data: {
            id: this.id,
            documentFilename: this.data.documentFilename,
          },
        })
        .afterClosed()
        .pipe(
          tap(() => this.spinnerService.show()),
          switchMap(result => {
            if (this.id && result === 'delete') {
              return this.documentAttachmentsService.removeDocument(this.id);
            } else {
              return of(null);
            }
          })
        )
        .subscribe(() => this.spinnerService.hide());
    }
  }

  onDownloadClicked() {
    if (this.id) {
      this.spinnerService.show();
      this.subs.sink = this.documentAttachmentsService
        .getDocument(this.id)
        .pipe(tap(t => saveAs(t, this.data.documentFilename)))
        .subscribe(() => this.spinnerService.hide());
    }
  }

  agInit(params: ICellRendererParams): void {
    this.isReadOnly = params.context.readOnly;
    this.data = params.data;
    this.id = params.value;
  }

  refresh(params: ICellRendererParams) {
    this.isReadOnly = params.context.readOnly;
    return false;
  }
}
